export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_676_COULDN_T_LOAD_NAVIGATION_': 'Couldn\'t load navigation...',
    '_675_LOADING_NAVIGATION_': 'Loading navigation...',
    '_678_LOGGED_IN_AS__NAME_': 'Logged in as {{name}}',
    '_108_LOGOUT': 'Logout',
    '_679_MY_PROFILE': 'My Profile',
    '_677_NAVIGATION_IS_EMPTY_': 'Navigation is empty...'
};
